// Pages that exist 1:1 in both the desktop and mobile MediaBlast modules. A desktop<->mobile
// redirect keeps the user on the same page for these; any other page falls back to the module root.
// Add a path here when a page is added to both media-blast-routing and media-blast-mobile-routing.
const MB_SHARED_SUBPATHS = ['/mcp-connect', '/mcp-connect/media-blast'];

// Path of a router URL without its query string and trailing slash.
export function normalizeRoutePath(url: string): string {
  const path = url.split('?')[0];
  return path.length > 1 && path.endsWith('/') ? path.slice(0, -1) : path;
}

export function mapMbSharedSubPath(url: string, fromPrefix: string, toPrefix: string): string | null {
  const subPath = normalizeRoutePath(url).slice(fromPrefix.length);
  return MB_SHARED_SUBPATHS.includes(subPath) ? `${toPrefix}${subPath}` : null;
}
